import React from "react";
import Masonry from "react-masonry-css";

import { DateTime } from "../components/DateTime";
import { GoogleTasksEmbeeded } from "../components/GoogleTasksEmbeed";
import { GoogleTasks } from "../components/GoogleTasks";
import { MakePhoto } from "../components/MakePhoto";
import { Routine } from "../components/Routine";
import { useDesktopMobile } from "../hooks/useDesktopMobile";
import { Accumulative } from "../components/Accumulative";
import { Anniversaries } from "../components/Anniversaries";
import { Relationships } from "../components/Relationships";
import { OpenGooglePhoto } from "../components/OpenGooglePhoto";
import { OpenFoodConstructor } from "../components/OpenFoodConstructor";

export const PageHome = () =>
    useDesktopMobile(
        <div className="App">
            <Masonry
                breakpointCols={3}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
                <Accumulative />
                {/* <OpenFoodConstructor /> */}
                <DateTime />
                {/* <OpenGooglePhoto /> */}
                <Routine />
                <div></div>
                <GoogleTasksEmbeeded />
                <div></div>
                <Anniversaries />
                <div></div>
                <Relationships />
            </Masonry>
        </div>,
        <div className="App">
            <div className="App__section">
                <DateTime />
            </div>
            {/* <div className="App__section">
                <OpenFoodConstructor />
            </div> */}
            <div className="App__section">
                <Routine />
            </div>
            {/* <div className="App__section"> */}
                {/* <GoogleTasks /> */}
                {/* <GoogleTasksEmbeeded /> */}
            {/* </div> */}
            <div className="App__section">
                <Accumulative />
            </div>
            <div className="App__section">
                <Anniversaries />
            </div>
            <div className="App__section">
                <Relationships />
            </div>
        </div>,
    );
